/**
 * @generated SignedSource<<11ccc61a4a1db73c75720faaaa93d9ba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment$data = {
  readonly jira: {
    readonly allNotificationProjectPreferences: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly project: {
            readonly id: string;
          } | null | undefined;
          readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData">;
        } | null | undefined;
      } | null | undefined>;
      readonly totalCount: number;
    };
  };
  readonly " $fragmentType": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment";
};
export type projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment$key = {
  readonly " $data"?: projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment">;
};

import ProjectNotificationsPaginationQuery_graphql from './ProjectNotificationsPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "jira",
  "allNotificationProjectPreferences"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": 50,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": ProjectNotificationsPaginationQuery_graphql
    }
  },
  "name": "projectNotificationsConfig_personalSettingsNotificationsConfigTable_ProjectNotificationsConfigInner_projectsPaginatedFragment",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "allNotificationProjectPreferences",
              "args": [
                {
                  "kind": "Variable",
                  "name": "cloudId",
                  "variableName": "cloudId"
                }
              ],
              "concreteType": "JiraNotificationProjectPreferenceConnection",
              "kind": "LinkedField",
              "name": "__projects_allNotificationProjectPreferences_connection",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraProjectNotificationPreferenceEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraNotificationProjectPreferences",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "FragmentSpread",
                            "name": "projectNotificationsConfigTable_personalSettingsNotificationsConfigTable_ProjectNotificationConfigTableNew_projectPreferencesData"
                          },
                          {
                            "concreteType": "JiraProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "RequiredField",
                                "field": {
                                  "kind": "ScalarField",
                                  "name": "id"
                                },
                                "action": "THROW",
                                "path": "jira.allNotificationProjectPreferences.edges.node.project.id"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "__typename"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "jira.allNotificationProjectPreferences.edges"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "totalCount"
                  },
                  "action": "THROW",
                  "path": "jira.allNotificationProjectPreferences.totalCount"
                },
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "endCursor"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "ScalarField",
                        "name": "__id"
                      },
                      "action": "THROW",
                      "path": "jira.allNotificationProjectPreferences.__id"
                    }
                  ]
                }
              ]
            },
            "action": "THROW",
            "path": "jira.allNotificationProjectPreferences"
          }
        ]
      },
      "action": "THROW",
      "path": "jira"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "94e7b6ce63a63c0a232c230663f65475";

export default node;
